import { useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  IconButton,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import FlightScaleRow from './FlightScaleRow';
import IndicateScaleCard from './IndicateScaleCard';
import KindOfFlightCard from './KindOfFlightCard';
import { useColors } from 'legacyfrontend/hooks/useColors';

const ColorButton = styled(Button)({
  color: '#3A3A3A',
  backgroundColor: 'transparent',
  '&:hover': {
    color: '#444',
  },
});

const DialogStyles = {
  title: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 auto auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 5px 16px 2rem',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0 0 2rem 0',
    maxHeight: { sm: 'inherit', lg: 600 },
    overflow: { sm: 'inherit' },
    alignSelf: 'center',
    width: { xs: '100%' },
  },
};

const FlightDetailDialog = ({ flight, kind, originId, destinationId, scales }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { background } = useColors();

  const validScales = useMemo(() => scales.filter((scale) => !scale.isNotScale), [scales]);

  const handleToggleDialog = () => setOpen((prev) => !prev);

  return (
    <>
      {isMobile ? (
        <IconButton
          onClick={handleToggleDialog}
          size='small'
          sx={{
            color: background,
          }}
        >
          <InfoIcon sx={{ color: background }} />
        </IconButton>
      ) : (
        <ColorButton color='info' onClick={handleToggleDialog} size='small' variant='text'>
          Más Detalles
        </ColorButton>
      )}

      <Dialog
        PaperProps={{
          sx: {
            borderRadius: '15px',
          },
        }}
        aria-labelledby='flight-detail-dialog'
        fullScreen={fullScreen}
        fullWidth
        maxWidth='md'
        onClose={handleToggleDialog}
        open={open}
      >
        <DialogTitle sx={DialogStyles.title}>
          <Typography fontSize={24} fontWeight={700}>
            Detalle de vuelo
          </Typography>
          <Button onClick={handleToggleDialog}>
            <CloseIcon style={{ fill: '#000' }} />
          </Button>
        </DialogTitle>

        <DialogContent sx={DialogStyles.content}>
          <KindOfFlightCard
            destinationId={destinationId}
            duration={flight[0].duration}
            isVueloDeIda={kind === 'ida'}
            isVueloDeVuelta={kind === 'vuelta'}
            originId={originId}
          />

          {flight.map((flightSegment, index) => (
            <div key={`flight-segment-${index}`}>
              <FlightScaleRow {...flightSegment} />
              {index < flight.length - 1 && validScales[index] && (
                <IndicateScaleCard info={validScales[index]} key={index} />
              )}
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FlightDetailDialog;
